import { forwardRef } from 'react';

export const Button = forwardRef(
  ({ className, active, reversed, ...props }, ref) => (
    <span
      {...props}
      ref={ref}
      className={`${className} ${active ? 'active' : ''}`}
    />
  ),
);
Button.displayName = 'Button';

export const Icon = forwardRef(({ className, ...props }, ref) => (
  <img
    src={require(`/src/icons/text-editor/${props.children}.svg`)}
    ref={ref}
    className={className}
    alt={props.children}
  />
));
Icon.displayName = 'Icon';

export const Toolbar = forwardRef(({ className, ...props }, ref) => (
  <Menu {...props} ref={ref} className={className} />
));
Toolbar.displayName = 'Toolbar';

export const Menu = forwardRef(({ className, ...props }, ref) => (
  <div {...props} ref={ref} className={className} />
));
Menu.displayName = 'Menu';
